export default __webpack_public_path__ + "static/media/trip_planner.5693eec6.png";